import { render, staticRenderFns } from "./blockhy.vue?vue&type=template&id=baf078c4&scoped=true&"
import script from "./blockhy.vue?vue&type=script&lang=js&"
export * from "./blockhy.vue?vue&type=script&lang=js&"
import style0 from "./blockhy.vue?vue&type=style&index=0&id=baf078c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf078c4",
  null
  
)

export default component.exports